import { render, staticRenderFns } from "./accountsGenerator.vue?vue&type=template&id=8356ea0c&"
import script from "./accountsGenerator.vue?vue&type=script&lang=js&"
export * from "./accountsGenerator.vue?vue&type=script&lang=js&"
import style0 from "./accountsGenerator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports